// state.js
import Vue from 'vue'
import Vuex from 'vuex'
import * as types from "./types"
import axios from "../http"
import api from "../api"

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    user: {
      "id": "",
    "userid": "",
    "username": "",
    "phonenum": "",
    "contact": "",
    "role": "",
    "roleid": "",
    "device": "",
    "device_info": "",
    "domain": "",
    "login_ip": "",
    "last_login": "",
    "status": ""
    },
    role: {
      "roleid": "admin",
      "rolename": "admin",
      "roleprivilege": "superPrivilege"
    },
    privMenu: {},
    deviceInfo:{},
    newDeviceNum:0,
    config:{}
  },
  actions: {
    LOAD_USER_INFO:({ commit,state }) =>{
      axios.get(api.user+"/"+ localStorage.getItem("id")).then((response) => {
        if(response.data.code == 0){
          if(response.data.user){
            console.log(response.data);
            commit('SET_USER_INFO',{user:response.data.user, role:response.data.role,privMenu:response.data.privMenu})
          }
        }

      }, (err) => {
        console.log(err)
      })
    },
     LOAD_CUSTON_INFO:({ commit,state }) =>{
       var list={}
       console.log(state)
       axios.get(api.devices+"/customtype").then((res)=>{
          if(res.data.code == 0){
            localStorage.setItem("custom_mode",res.data.custom_mode)
            if(res.data.custom_mode=="on"){
              res.data.custom_type.forEach((obj) => {
                const [key, value] = Object.entries(obj)[0];
                if (!list[value]) {
                  list[value] = key;
                } else {
                  let count = 1;
                  while (list[`${value}_${count}`]) {
                    count++;
                  }
                  list[`${value}_${count}`] = key;
                }
              });
              // res.data.custom_type.forEach((obj)=>{
              //   const [key, value] = Object.entries(obj)[0];
              //   list[value] = key;


              // })
              //  Object.keys(list).forEach((key, index, array) => {
              //    const count = array.slice(0, index).filter(k => k === key).length;
              //    list[count > 0 ? `${key}_${count}` : key] = obj[key];
              //  });
               console.log(list)
              var extractedList={
                "OM": [],
                "MX": [],
                "IPPhone": [],
                "SBC":[]
              }

               extractedList.OM= res.data.custom_type.map(obj => Object.values(obj)).flat();
               extractedList.OM =  extractedList.OM.map((value, index, array) => {
                 const count = array.slice(0, index).filter(v => v === value).length;
                 return count > 0 ? `${value}_${count}` : value;
               });
              commit("SET_CONFIG_INFO", { deviceAlias: list,deviceList:extractedList });
            }
          }
       })
     }

  },
  mutations: {
    [types.LOGIN]: (state, data) => {
      localStorage.token = data;
    },
    SET_USER_NAME: (state,userid) => {
      state.account = userid;
      localStorage.setItem("account",userid);
    },
    SET_DEVICE_INFO:(state,deviceInfo)=>{
      state.deviceInfo = deviceInfo;
      localStorage.setItem("deviceInfo",JSON.stringify(deviceInfo));
    },
    SET_TASK_INFO:(state,taskInfo)=>{
      state.taskInfo = taskInfo;
      localStorage.setItem("taskInfo",JSON.stringify(taskInfo));
    },
    SET_USER_INFO: (state,{user,role,privMenu}) => {
      if(user){
        state.user = user
        state.role = role
        state.privMenu = privMenu
        localStorage.setItem("user",JSON.stringify(user));
        localStorage.setItem("role",JSON.stringify(role));
        localStorage.setItem("privMenu",JSON.stringify(privMenu));
      }

    },

    SET_CONFIG_INFO: (state,config) =>{ //配置文件
        state.config = { ...state.config, ...config }; // 合并 config 到 state.config

      localStorage.setItem("umsConfig",JSON.stringify(state.config));
    }
  },
  getters: {
    privMenu: state => state.privMenu,
    user: state => state.user,
    role: state => state.role,
    deviceInfo:state => state.deviceInfo,
    taskInfo:state => state.taskInfo,
    config:state => state.config
  }
})



// WEBPACK FOOTER //
// ./src/store/state.js